// Frontend-only value sets for the brief surface. See enums/shell.ts for the rationale.

export const BRIEF_READINESS_STATES = [
  "complete",
  "incomplete",
  "not_applicable",
] as const;
export type BriefReadinessState = (typeof BRIEF_READINESS_STATES)[number];
export const BRIEF_READINESS_STATE = {
  COMPLETE: "complete",
  INCOMPLETE: "incomplete",
  NOT_APPLICABLE: "not_applicable",
} as const satisfies Record<string, BriefReadinessState>;

export const BRIEF_SOURCE_TYPES = ["issue", "map"] as const;
export type BriefSourceType = (typeof BRIEF_SOURCE_TYPES)[number];
export const BRIEF_SOURCE_TYPE = {
  ISSUE: "issue",
  MAP: "map",
} as const satisfies Record<string, BriefSourceType>;

export const BRIEF_STATUSS = [
  "Draft",
  "Needs input",
  "Ready for delivery",
] as const;
export type BriefStatus = (typeof BRIEF_STATUSS)[number];
export const BRIEF_STATUS = {
  DRAFT: "Draft",
  NEEDS_INPUT: "Needs input",
  READY_FOR_DELIVERY: "Ready for delivery",
} as const satisfies Record<string, BriefStatus>;

export const BRIEF_DETAIL_KINDS = ["readable", "technical"] as const;
export type BriefDetailKind = (typeof BRIEF_DETAIL_KINDS)[number];
export const BRIEF_DETAIL_KIND = {
  READABLE: "readable",
  TECHNICAL: "technical",
} as const satisfies Record<string, BriefDetailKind>;

export const BRIEF_EDIT_SECTIONS = [
  "identity",
  "objective",
  "required-change",
  "scope",
  "requirements",
  "acceptance",
  "questions",
] as const;
export type BriefEditSection = (typeof BRIEF_EDIT_SECTIONS)[number];
export const BRIEF_EDIT_SECTION = {
  IDENTITY: "identity",
  OBJECTIVE: "objective",
  REQUIRED_CHANGE: "required-change",
  SCOPE: "scope",
  REQUIREMENTS: "requirements",
  ACCEPTANCE: "acceptance",
  QUESTIONS: "questions",
} as const satisfies Record<string, BriefEditSection>;
